/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import Hero from "../../../components/hero/Hero";
import "./doctor-details.css";
import { ImLocation } from "react-icons/im";
import { FaMobileAlt } from "react-icons/fa";
import { AiOutlinePhone } from "react-icons/ai";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import person from "../../../images/doctors/person.png";
import { BsFillTrashFill } from "react-icons/bs";
import { AiFillLike, AiOutlineEdit, AiOutlineLike } from "react-icons/ai";
import AddComment from "../../../components/comments/AddComment";
import CommentList from "../../../components/comments/CommentList";
import swal from "sweetalert";
import UpdateDoctorModal from "./UpdateDoctorModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteDoctor,
  fetchSingleDoctor,
  toggleLikeDoctor,
} from "../../../redux/apiCalls/doctorsApiCalls";

const DoctorDetails = () => {
  const dispatch = useDispatch();
  const doctor = useSelector((state) => state.doctor.doctor);
  const user = useSelector((state) => state.auth.user);
  const { id } = useParams();
  const [updateDoctor, setUpdateDoctor] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchSingleDoctor(id));
  }, [id]);

  // const updateImagesubmitHandler = (e) => {
  //   e.preventDefault();
  //   if (!file) {
  //     return toast.warning("لم يتم اختيار صورة");
  //   }
  //   const formData = new FormData();
  //   formData.append("image", file);
  //   dispatch(updateDoctorImage(formData, doctor?._id));
  // };

  const navigate = useNavigate();
  //Delete doctor handler
  const deleteDoctorHandler = () => {
    swal({
      title: "هل تريد فعلا الحذف ؟",
      text: "لن تستطيع استعادة البيانات ثانية",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteDoctor(doctor?._id));
        navigate(`/profile/${user?._id}`);
      }
    });
  };

  return (
    <div className="doctor-details">
      <div className="doctor-details-hero">
        <Hero pageTitle="" pageDiscription="" />
      </div>
      <div className="doctor-container-wrapper">
        <div className="doctor-container">
          <div className="doctor-container-img-wrapper">
            <img src={person} alt="image" />
            {/* <span className="verified-details">
              <BsFillPatchCheckFill />
            </span> */}
            {/* {user?._id === doctor?.user?._id && (
              <form
                onSubmit={updateImagesubmitHandler}
                className="update-doctor-image"
              >
                <label htmlFor="file" className="update-doctor-label">
                  <BsFillCameraFill className="update-doctor-label ms-2" />
                </label>
                <input
                  onChange={(e) => setFile(e.target.files[0])}
                  type="file"
                  name="file"
                  id="file"
                />
                <button type="submit" className="image-button">
                  تحميل صورة
                </button>
              </form>
            )} */}
            <div className="doctor-name"> {doctor?.name} </div>
            <div className="doctor-title-"> {doctor?.title} </div>
            <div className="contact-wrapper">
              <div className="doctor-mobile">
                <FaMobileAlt
                  size={20}
                  color="#014160"
                  className="doctor-mobile ms-1"
                />
                {doctor?.mobile}
              </div>
              <div className="doctor-phone">
                <AiOutlinePhone
                  size={23}
                  color="#014160"
                  className="doctor-phone ms-1"
                />
                {doctor?.tell}
              </div>
              <div className="doctor-address">
                <ImLocation
                  className="doctor-address ms-1"
                  size={20}
                  color="#014160"
                />
                {doctor?.city}
              </div>
            </div>
          </div>
          <div className="doctor-container-info-wrapper">
            <div className="doctor-container-info-wrapper-multi-1">
              <div className="doctor-container-info-wrapper-multi-2">
                <div>
                  <strong>القسم</strong>
                  <p> {doctor?.department} </p>
                </div>
                <div>
                  <strong>كيفية الحجز</strong>
                  <p>{doctor?.registrationType}</p>
                </div>
              </div>
              <div className="doctor-container-info-wrapper-multi-address">
                <div>
                  <strong>العنوان</strong>
                  <p>{doctor?.address}</p>
                </div>
              </div>
            </div>
            <div className="doctor-container-info-wrapper-multi-3">
              <strong>عن الطبيب</strong>
              <p>{doctor?.description}</p>
            </div>
            <div className="doctor-details-icon-wrapper">
              {user?._id === doctor?.user?._id && (
                <div className="options">
                  <span>
                    <BsFillTrashFill
                      onClick={deleteDoctorHandler}
                      color="#e23836"
                    />
                  </span>
                  <span>
                    <AiOutlineEdit
                      color="#014160"
                      onClick={() => setUpdateDoctor(true)}
                    />
                  </span>
                </div>
              )}

              <div className="like">
                <small>{doctor?.likes?.length}</small>
                {user && (
                  <small
                    onClick={() => dispatch(toggleLikeDoctor(doctor?._id))}
                  >
                    {doctor?.likes?.includes(user?._id) ? (
                      <AiFillLike className="like" />
                    ) : (
                      <AiOutlineLike className="like" />
                    )}
                  </small>
                )}
              </div>
            </div>
          </div>
        </div>

        {user ? (
          <AddComment doctorId={doctor?._id} />
        ) : (
          <div className="add-comment-tag">
            اذا كنت تريد كتابة تعليك ، عليك بالتسجيل فى الموقع ..
          </div>
        )}

        <CommentList comments={doctor?.comments} />

        {updateDoctor && (
          <UpdateDoctorModal
            setUpdateDoctor={setUpdateDoctor}
            doctor={doctor}
          />
        )}
      </div>
    </div>
  );
};

export default DoctorDetails;
